import type { ApplicantTaskDuePreset } from 'types/graphql'

/** Any open task, regardless of deadline. Web-only value: it sends no due preset. */
export const ANY_ACTIVE_TASK = 'ANY_ACTIVE' as const

export type TaskDeadlineValue = ApplicantTaskDuePreset | typeof ANY_ACTIVE_TASK

/** Ordered soonest to farthest; the menu renders this list as is. */
export const TASK_DEADLINE_OPTIONS: {
  label: string
  value: TaskDeadlineValue
}[] = [
  { label: 'Active (any deadline)', value: ANY_ACTIVE_TASK },
  { label: 'Overdue', value: 'OVERDUE' },
  { label: 'Due today', value: 'TODAY' },
  { label: 'Due tomorrow', value: 'TOMORROW' },
  { label: 'Due this week', value: 'THIS_WEEK' },
  { label: 'Due in the next 7 days', value: 'NEXT_7_DAYS' },
  { label: 'Due next week', value: 'NEXT_WEEK' },
  { label: 'Due in the next 30 days', value: 'NEXT_30_DAYS' },
  { label: 'No deadline', value: 'NO_DEADLINE' },
]

/** Any open task with at least one assignee. Web-only value: maps to `assigned`. */
export const ANY_ASSIGNEE = 'ANY_ASSIGNEE' as const
export const ANY_ASSIGNEE_OPTION = {
  label: 'Any assignee',
  value: ANY_ASSIGNEE,
}

/**
 * An "Any …" value is a superset of the other options, so picking it clears
 * them and picking any other option clears it.
 */
export const applyAnyExclusivity = (
  next: string[],
  previous: string[],
  anyValue: string
): string[] => {
  const added = next.find((v) => !previous.includes(v))
  if (added === anyValue) return [anyValue]
  return next.length > 1 ? next.filter((v) => v !== anyValue) : next
}
